const linkCls = "_61l1abytyk";

export { linkCls };
import "./atom.link.style.linaria.module.css";
//# sourceMappingURL=atom.link.style.js.map
